import styled from 'styled-components';

export const InsightsListSectionRoot = styled.div`
  height: 100%;
`;
